export default __webpack_public_path__ + "static/media/periodo-mes.2559bb82.gif";